interface Shop {
  name: string;
  category: string[];
  description: string;
  location: string;
  reviewCount: number;
  photoCount: number;
  verified: boolean;
}

interface StickyCompactHeaderProps {
  activeTab: string;
  onTabClick: (id: string) => void;
  show: boolean;
  shop: Shop;
}

const tabs = [
  { id: 'summary', label: '요약' },
  { id: 'photos', label: '사진' },
  { id: 'reviews', label: '후기' },
  { id: 'info', label: '정보' },
];

export default function StickyCompactHeader({ activeTab, onTabClick, show, shop }: StickyCompactHeaderProps) {
  if (!show) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-[#E8E2DA] shadow-md">
      <div className="lg:max-w-[1200px] lg:mx-auto px-6">
        <div className="flex items-center justify-between py-2">
          <div className="flex items-center gap-4">
            <div>
              <h2 className="text-sm md:text-base font-bold text-[#121B35]">{shop.name}</h2>
              <div className="flex items-center gap-2 text-xs md:text-sm text-[#536079]">
                <span>{shop.category?.join(' · ')}</span>
                <span className="text-[#E8E2DA]">·</span>
                <span>후기 {shop.reviewCount}개</span>
                <span className="text-[#E8E2DA]">·</span>
                <span>사진 {shop.photoCount}장</span>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button className="bg-[#121B35] text-white text-xs md:text-sm font-semibold px-4 py-2 rounded-lg whitespace-nowrap active:opacity-90 transition-opacity">
              상담 문의하기
            </button>
            {/* <button className="bg-white text-[#121B35] text-xs md:text-sm font-medium px-4 py-2 rounded-lg border border-[#E8E2DA] whitespace-nowrap active:bg-[#F7F2EA] transition-colors">
              예약하기
            </button> */}
          </div>
        </div>
        <div className="flex gap-2 pb-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabClick(tab.id)}
              className={`px-4 py-1.5 rounded-full text-xs md:text-sm transition-colors whitespace-nowrap ${
                activeTab === tab.id
                  ? 'bg-[#121B35] text-white font-medium'
                  : 'text-[#536079] hover:text-[#121B35]'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}